import TranslationText from '@Components/Utilities/TranslationText';

const MyListingsPostings = (props) => {
    return (
        <div className='account-additional-section'>
            <div className='grey-box'>
                <h4><TranslationText tKey='sandhills.tradepubwebsite.mvc.mylistingspostings' /></h4>
                <div className='flex-col'>
                    <div className='col col-6'>
                        <a href={props.RequestVerificationCodeUrl.Key} className='block-button'><strong>{props.RequestVerificationCodeUrl.Value}</strong></a>
                    </div>
                    <div className='col col-6'>
                        <a href={props.GenerateVerificationCodeUrl.Key} className='block-button'><strong>{props.GenerateVerificationCodeUrl.Value}</strong></a>
                    </div> 
                </div>
            </div>
        </div>
    );
};

export default MyListingsPostings;